import {
  MAX_CUSTOM_SERVICE_RATE,
  MIN_CUSTOM_SERVICE_RATE,
} from "./coach.constants"
import Dashboard from "./dashboard/dashboard.module"

const state = {}
const mutations = {}
const actions = {}
const getters = {
  minCustomServiceRate: () => MIN_CUSTOM_SERVICE_RATE,
  maxCustomServiceRate: () => MAX_CUSTOM_SERVICE_RATE,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    Dashboard,
  },
}



// WEBPACK FOOTER //
// ./src/store/coach/coach.module.js